/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GoogleAdsSuccessfulAccountRuntimeStatus
 */
export interface GoogleAdsSuccessfulAccountRuntimeStatus {
    /**
     * 
     * @type {string}
     * @memberof GoogleAdsSuccessfulAccountRuntimeStatus
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleAdsSuccessfulAccountRuntimeStatus
     */
    name?: string;
}

/**
 * Check if a given object implements the GoogleAdsSuccessfulAccountRuntimeStatus interface.
 */
export function instanceOfGoogleAdsSuccessfulAccountRuntimeStatus(value: object): value is GoogleAdsSuccessfulAccountRuntimeStatus {
    return true;
}

export function GoogleAdsSuccessfulAccountRuntimeStatusFromJSON(json: any): GoogleAdsSuccessfulAccountRuntimeStatus {
    return GoogleAdsSuccessfulAccountRuntimeStatusFromJSONTyped(json, false);
}

export function GoogleAdsSuccessfulAccountRuntimeStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleAdsSuccessfulAccountRuntimeStatus {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function GoogleAdsSuccessfulAccountRuntimeStatusToJSON(json: any): GoogleAdsSuccessfulAccountRuntimeStatus {
    return GoogleAdsSuccessfulAccountRuntimeStatusToJSONTyped(json, false);
}

export function GoogleAdsSuccessfulAccountRuntimeStatusToJSONTyped(value?: GoogleAdsSuccessfulAccountRuntimeStatus | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

